import type React from 'react';

const sizeClassMap = {
  sm: 'w-4 h-4 border-[3px]',
  md: 'w-6 h-6 border-4',
  lg: 'w-10 h-10 border-[6px]',
} as const;

type SpinnerSize = keyof typeof sizeClassMap;

interface SpinnerProps {
  size?: SpinnerSize;
  className?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({ size = 'md', className }) => (
  <div
    className={`${sizeClassMap[size]} rounded-full border-primary-lightest border-t-primary-base animate-spin flex-shrink-0 ${className ?? ''}`}
  />
);
